import ApiData from './models/ApiData';

export const adoptPromiseAllData = (promiseAllArray: ApiData[]) => {
  return promiseAllArray.map((promise) => promise.data);
};
